// Activity Connection - Calendar Builder
// Author: Allen Peloquin (PNDLM)
// 
// GridDocumentReducer.js
// Redux reducers take app actions and update state
//
import Immutable, { List } from 'immutable'
import { createStore, combineReducers } from 'redux'
import * as actions from './CurrentUserActions'
import User from '../model/User'

// app runs off of this model
export const initialState = {
	currentUser: User.default()
}

export function currentUser(state = [], action) {
	switch (action.type) {
		case actions.REDUX_INIT:
			let bootstrapWithClientDefaults = Object.assign(User.default(), state)
			state = User.buildFromJson(bootstrapWithClientDefaults)
		default:
			break
	}
	return state
}


// WEBPACK FOOTER //
// ./src/data/CurrentUserReducer.js